var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon123(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 8,
    viewBox: "0 0 19 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4165 7.5V2.25H0.666504V0.5H4.1665V7.5H2.4165ZM6.49984 7.5V4.58333C6.49984 4.25278 6.61164 3.97569 6.83525 3.75208C7.05887 3.52847 7.33595 3.41667 7.6665 3.41667H9.99984V2.25H6.49984V0.5H10.5832C10.9137 0.5 11.1908 0.611806 11.4144 0.835417C11.638 1.05903 11.7498 1.33611 11.7498 1.66667V3.41667C11.7498 3.74722 11.638 4.02431 11.4144 4.24792C11.1908 4.47153 10.9137 4.58333 10.5832 4.58333H8.24984V5.75H11.7498V7.5H6.49984ZM13.4998 7.5V5.75H16.9998V4.58333H14.6665V3.41667H16.9998V2.25H13.4998V0.5H17.5832C17.9137 0.5 18.1908 0.611806 18.4144 0.835417C18.638 1.05903 18.7498 1.33611 18.7498 1.66667V6.33333C18.7498 6.66389 18.638 6.94097 18.4144 7.16458C18.1908 7.38819 17.9137 7.5 17.5832 7.5H13.4998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon123);
export default __webpack_public_path__ + "static/media/icon_123.388a7b14627d502401c2d48d8eb74d3f.svg";
export { ForwardRef as ReactComponent };